import { useWSModal } from "@wingspanhq/fe-component-library";
import { ModalSelectAccounts } from "./index";

export const useModalSelectAccounts = () =>
  useWSModal(ModalSelectAccounts, {
    title: "Select Account",
    size: "S",
    fullScreen: true
  });